import React from "react";
import "./OrderComplete.scss";
import { Link } from "react-router-dom";

const OrderComplete = () => {
  return (
    <div className="order_complete_page w-[96%]">
      <div className="order_complete_page_container">
        <div className="min-h-[50vh] flex justify-center items-center flex-col">
          <div className="text-[30px] font-medium">Thank you! 🎉</div>
          <div className="text-[18px] text-center">
            Your order has been successfully received
          </div>
          <div className="text-[18px] text-center">
            You will receive your order within 7 business days.😍
          </div>
          <Link
            to={"/"}
            className="bg-[var(--black-color)] button w-fit px-7 relative text-center group py-2 rounded-3xl mt-5 flex cursor-pointer  justify-center items-center gap-2"
          >
            <button
              type="submit"
              className=" outline-none border-none text-white text-[15px]"
            >
              Continue Shopping
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderComplete;
